import FormField from '@/components/FormField'
import PasswordInput from '@/components/PasswordInput'
import { useBranches } from '@/shared/api/hooks/useBranches'
import {
    Stack,
    Button,
    SimpleGrid,
    FormControl,
    FormErrorMessage,
    FormLabel
} from '@chakra-ui/react'
import { Controller } from 'react-hook-form'
import ReactSelect from 'react-select'

interface CoParentRegistrationFormProps {
    onSubmit: (data: any) => Promise<void>
    register: any
    control: any
    errors: Record<keyof any, { message?: string }>
    isSubmitting: boolean
}

export default function CoParentRegistrationForm({
    onSubmit,
    register,
    control,
    errors,
    isSubmitting
}: CoParentRegistrationFormProps) {
    const { branches, loading: branchLoading } = useBranches()

    return (
        <Stack spacing={4}>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                <FormField
                    label="First Name"
                    name="firstName"
                    type="text"
                    required
                    register={register}
                    error={errors.firstName}
                />
                <FormField
                    label="Last Name"
                    name="lastName"
                    type="text"
                    register={register}
                    error={errors.lastName}
                />
            </SimpleGrid>

            <FormControl isInvalid={Boolean(errors.branch)} isRequired>
                <FormLabel>Branch</FormLabel>
                <Controller
                    name="branch"
                    control={control}
                    render={({ field }) => (
                        <ReactSelect
                            {...field}
                            isSearchable
                            placeholder="choose branch"
                            options={branches}
                            isLoading={branchLoading}
                        />
                    )}
                />
                <FormErrorMessage>
                    {errors.branch && errors.branch.message}
                </FormErrorMessage>
            </FormControl>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                <FormField
                    label="Email"
                    name="email"
                    type="email"
                    required
                    register={register}
                    error={errors.email}
                />
                <FormControl isInvalid={Boolean(errors.password)} isRequired>
                    <FormLabel>Password</FormLabel>
                    <Controller
                        name="password"
                        control={control}
                        render={({ field }) => <PasswordInput {...field} />}
                    />
                    <FormErrorMessage>
                        {errors.password && errors.password.message}
                    </FormErrorMessage>
                </FormControl>
            </SimpleGrid>

            <FormField
                label="Profile Picture"
                name="picture"
                type="file"
                accept="image/*"
                required
                register={register}
                error={errors.picture}
                helperText="Maximum image size allowed is 4MB"
            />

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                <FormField
                    label="Phone Number"
                    name="phoneNumber"
                    type="tel"
                    required
                    register={register}
                    error={errors.phoneNumber}
                />

                <FormField
                    label="Relationship"
                    name="relationship"
                    type="select"
                    required
                    register={register}
                    error={errors.relationship}
                >
                    <option value="Father">Father</option>
                    <option value="Mother">Mother</option>
                </FormField>
            </SimpleGrid>

            <FormField
                label="Address"
                name="address"
                type="text"
                register={register}
                error={errors.address}
            />

            <Button
                mt={6}
                type="submit"
                size="lg"
                colorScheme="brand"
                isLoading={isSubmitting}
                loadingText="Registering"
                onClick={onSubmit}
            >
                Submit Co-parent
            </Button>
        </Stack>
    )
}
